var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SelectionWithMultimediaMixin, SelectionWithNoteSourceCitationMixin } from './mixin';
import { SelectionIndividualReference, SelectionFamilyEvent } from './internal';
import { SelectionRecord } from './base';
var SelectionFamilyRecord = /** @class */ (function (_super) {
    __extends(SelectionFamilyRecord, _super);
    function SelectionFamilyRecord() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /* Events */
    SelectionFamilyRecord.prototype.getEventAnnulment = function () {
        return this.get("ANUL" /* Annulment */, null, SelectionFamilyEvent);
    };
    SelectionFamilyRecord.prototype.getEventCensus = function () {
        return this.get("CENS" /* Census */, null, SelectionFamilyEvent);
    };
    SelectionFamilyRecord.prototype.getEventDivorce = function () {
        return this.get("DIV" /* Divorce */, null, SelectionFamilyEvent);
    };
    SelectionFamilyRecord.prototype.getEventDivorceFiled = function () {
        return this.get("DIVF" /* DivorceFiled */, null, SelectionFamilyEvent);
    };
    SelectionFamilyRecord.prototype.getEventEngagement = function () {
        return this.get("ENGA" /* Engagement */, null, SelectionFamilyEvent);
    };
    SelectionFamilyRecord.prototype.getEventMarriageBann = function () {
        return this.get("MARB" /* MarriageBan */, null, SelectionFamilyEvent);
    };
    SelectionFamilyRecord.prototype.getEventMarriageContract = function () {
        return this.get("MARC" /* MarriageContract */, null, SelectionFamilyEvent);
    };
    SelectionFamilyRecord.prototype.getEventMarriage = function () {
        return this.get("MARR" /* Marriage */, null, SelectionFamilyEvent);
    };
    SelectionFamilyRecord.prototype.getEventMarriageLicense = function () {
        return this.get("MARL" /* MarriageLicense */, null, SelectionFamilyEvent);
    };
    SelectionFamilyRecord.prototype.getEventMarriageSettlement = function () {
        return this.get("MARS" /* MarriageSettlement */, null, SelectionFamilyEvent);
    };
    SelectionFamilyRecord.prototype.getEventResidence = function () {
        return this.get("RESI" /* Residence */, null, SelectionFamilyEvent); // Residence is normally an attribute
    };
    SelectionFamilyRecord.prototype.getEventOther = function () {
        return this.get("EVEN" /* Event */, null, SelectionFamilyEvent);
    };
    /* End events */
    SelectionFamilyRecord.prototype.getHusband = function () {
        return this.get("HUSB" /* Husband */, null, SelectionIndividualReference);
    };
    SelectionFamilyRecord.prototype.getWife = function () {
        return this.get("WIFE" /* Wife */, null, SelectionIndividualReference);
    };
    SelectionFamilyRecord.prototype.getChild = function () {
        return this.get("CHIL" /* Child */, null, SelectionIndividualReference);
    };
    SelectionFamilyRecord.prototype.getChildrenCount = function () {
        return this.get("NCHI" /* ChildrenCount */);
    };
    return SelectionFamilyRecord;
}(SelectionWithMultimediaMixin(SelectionWithNoteSourceCitationMixin(SelectionRecord))));
export { SelectionFamilyRecord };
//# sourceMappingURL=SelectionFamilyRecord.js.map